export function arrayAt<T>(arr: T[], idx: number): T | undefined {
  return arr[idx];
}

export function isNonEmptyArray<T>(arr: T[]): arr is [T, ...T[]] {
  return arr.length > 0;
}
